import { wrapUrlForProxy } from "./url.helpers"

const IMAGE_SRC_ATTRIBUTE_PATTERN = /\{.*\}$/g
const IMAGE_SRC_URL_PATTERN =
    // eslint-disable-next-line no-useless-escape
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g

export const isImageSrcAttribute = (imgSrc?: string) =>
    Boolean(imgSrc?.match(IMAGE_SRC_ATTRIBUTE_PATTERN))

export const isImageSrcUrl = (imgSrc?: string) => Boolean(imgSrc?.match(IMAGE_SRC_URL_PATTERN))

export const checkImage = async (url: string, addProxy?: boolean) => {
    try {
        const finalUrl = addProxy ? wrapUrlForProxy(url, "image") : url
        const res = await fetch(finalUrl)

        if (!res.ok) return false

        const fileBuffer = await res.blob()
        if (fileBuffer.type.startsWith("image/")) return true
        else return false
    } catch (e) {
        console.error(e)
        return false
    }
}
